import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=f6e97ce8&scoped=true&"
import script from "./setRole.vue?vue&type=script&lang=js&"
export * from "./setRole.vue?vue&type=script&lang=js&"
import style0 from "./setRole.vue?vue&type=style&index=0&id=f6e97ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e97ce8",
  null
  
)

export default component.exports